import { Component, OnDestroy, OnInit } from '@angular/core';
import { PayrollIncomeType, Settings } from '@app/modules/time-tracking/interfaces/settings.interface';
import { NotifyService } from '@app/services';
import { Subscription } from 'rxjs';
import { TimeTrackingSettingsService } from '../../services/time-tracking-settings.service';

@Component({
    selector: 'app-payroll-integration-card',
    templateUrl: './payroll-integration-card.component.html',
    styleUrls: ['./payroll-integration-card.component.scss'],
})
export class PayrollIntegrationCardComponent implements OnInit, OnDestroy {
    isLoading = false;
    settings: Settings = {};
    subscription: Subscription | null = null;
    incomeTypes: PayrollIncomeType[] = [];

    constructor(
        private timeTrackingSettingsService: TimeTrackingSettingsService,
        private notifyService: NotifyService
    ) {}

    get payrollEmployeesCount(): number {
        return this.settings?.counts?.payrollEmployeesEnabled ?? 0;
    }

    async ngOnInit(): Promise<void> {
        this.isLoading = true;
        try {
            this.settings = await this.timeTrackingSettingsService.get();
            this.incomeTypes = this.settings.payrollIncomeTypes ?? [];
        } catch (err) {
            this.notifyService.error(err);
        } finally {
            this.isLoading = false;
        }

        this.subscription = this.timeTrackingSettingsService.subject.subscribe(async () => {
            this.settings = await this.timeTrackingSettingsService.get();
        });
    }

    async ngOnDestroy(): Promise<void> {
        this.subscription?.unsubscribe();
    }
}
